/**
 * High level router.
 *
 * Note: It's recommended to compose route components (e.g. AuthPage, BasePage) and use Routes/Route.
 */

import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./application/Auth";
import ErrorsPage from "./application/ErrorsExamples/ErrorsPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";

export function RoutesComponent() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual
  );

  return (
    <Routes>
      <Route path="/auth/*" element={!isAuthorized ? <AuthPage /> : <Navigate to="/" replace />} />
      <Route path="/error/*" element={<ErrorsPage />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route
        path="*"
        element={
          !isAuthorized ? (
            <Navigate to="/auth/login" replace />
          ) : (
            <Layout>
              <BasePage />
            </Layout>
          )
        }
      />
    </Routes>
  );
}
